export const RUN_VARIANT = {
    ALL_CREATED: 'ALL_CREATED',
    PARTIAL: 'PARTIAL',
    NONE_CREATED: 'NONE_CREATED',
} as const;

export type RunVariant = typeof RUN_VARIANT[keyof typeof RUN_VARIANT];

/** Outcome of one draft within a submission run. */
export interface ICreateRmaOutcome {
    draftIndex: number;
    fulfillmentLabel: string;
    isCreated: boolean;
    rmaId?: string;
    errorMessage?: string;
    /** First selected item name for the result modal row descriptor (FR12). */
    firstItemName?: string;
    /** Server copy for a single-outcome run (AC1 parity with today's modal). */
    message?: string;
    messageTitle?: string;
    /** Soft warning from a successful create-rma response (AC1). */
    warningMessage?: string;
}

/** Internal error markers stored on drafts; not shown directly in the modal UI. */
export const SUBMISSION_ERROR = {
    CUSTOMER_PAYMENT_REQUIRED: '__CUSTOMER_PAYMENT_REQUIRED__',
    SUBMISSION_FAILED: '__SUBMISSION_FAILED__',
} as const;

/** A blocking reason attributed to one fulfillment for the submit bar (FR9). */
export interface IFulfillmentBlockingReason {
    draftIndex: number;
    reasonKey: string;
}

/** Internal outcome marker: manager approval was declined mid-run; not shown to merchants. */
export const SUBMISSION_CREDENTIALS_DECLINED = '__CREDENTIALS_DECLINED__';

export function isSubmissionCredentialsDeclined(errorMessage?: string): boolean {
    return errorMessage === SUBMISSION_CREDENTIALS_DECLINED;
}

/** Translation keys in scope `dashboard-create-rma` for per-fulfillment submit blocks. */
export const CREATE_RMA_DRAFT_BLOCK_REASON = {
    LOADING: 'SUBMIT_BLOCKED_LOADING',
    SELECT_SHIPPING_OPTION: 'SUBMIT_BLOCKED_SELECT_SHIPPING_OPTION',
    CUSTOMER_PAYMENT_REQUIRED: 'BLOCK_PAID_RMA_TOOLTIP',
    OUT_OF_POLICY: 'THIS_RMA_IS_OUT_OF_POLICY_NOTE_TEXT',
    MULTIPLE_RETURNS: 'SUBMIT_BLOCKED_MULTIPLE_RETURNS',
} as const;
